import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { EventConfig } from '../interfaces/event-script.models';

/**
 * Componente para listar e gerenciar eventos configurados em um componente
 */
@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EventListComponent {
  @Input() events: EventConfig[] = [];
  @Output() edit = new EventEmitter<EventConfig>();
  @Output() delete = new EventEmitter<EventConfig>();
  @Output() toggle = new EventEmitter<EventConfig>();
  @Output() duplicate = new EventEmitter<EventConfig>();

  /**
   * Emite evento de edição
   */
  onEdit(event: EventConfig): void {
    this.edit.emit(event);
  }

  /**
   * Emite evento de exclusão
   */
  onDelete(event: EventConfig): void {
    this.delete.emit(event);
  }

  /**
   * Emite evento de toggle (enable/disable)
   */
  onToggle(event: EventConfig): void {
    this.toggle.emit(event);
  }

  /**
   * Emite evento de duplicação
   */
  onDuplicate(event: EventConfig): void {
    this.duplicate.emit(event);
  }

  /**
   * Retorna cor do badge baseado no modo
   */
  getModeColor(mode: 'simple' | 'expert'): string {
    return mode === 'simple' ? 'blue' : 'orange';
  }

  /**
   * Retorna label do tipo de evento
   */
  getEventTypeLabel(eventType: 'onChange' | 'onInit'): string {
    return eventType === 'onChange' ? 'Ao Mudar' : 'Ao Inicializar';
  }

  /**
   * Retorna ícone do tipo de evento
   */
  getEventTypeIcon(eventType: 'onChange' | 'onInit'): string {
    return eventType === 'onChange' ? 'sync' : 'rocket';
  }
}



